export default __webpack_public_path__ + "static/media/call-center-global.d67ffd0c.jpg";